import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { BackIcon } from "../../../../../components/icons";

const HeaderSection = ({
    authDetailBooking,
    typo14,
}) => {
    const { t, i18n } = useTranslation();
    const currentLanguage = i18n.language;

    return (
        <div className="tw:flex tw:flex-wrap tw:items-center tw:gap-6 tw:pb-[42px]">
            <Link
                to="/my-page/bookings"
                className="tw:inline-flex tw:items-center tw:gap-[10px] tw:rounded-[5px] tw:border tw:border-[#e8e8e8] tw:bg-[#e8e8e8] tw:px-3 tw:py-2 tw:text-[#282828] tw:!no-underline"
            >
                <BackIcon
                    color="#8D8D8D"
                    width={7}
                    height={10}
                />
                <span className={`tw:font-hanken-grotesk ${typo14} tw:text-[#282828]`}>{t("bookingDetail.headerSection.back")}</span>
            </Link>
            <div className="tw:flex tw:flex-col">
                <div className={`tw:font-hanken-grotesk tw:font-medium tw:text-[#7c7b7b] ${typo14}`}>
                    {t("bookingDetail.headerSection.name", { 
                        passengerName: `${authDetailBooking?.customer?.pronounced || ""} ${authDetailBooking?.customer?.name}`
                        })}
                </div>
                <div className="tw:font-hanken-grotesk tw:text-[30px] tw:font-semibold tw:leading-normal tw:text-[#212529]">
                    {t("bookingDetail.headerSection.bookingId", { bookingId: authDetailBooking?.key })}
                </div>
            </div>
        </div>
    );
};

export default HeaderSection;